import Vue from "vue";

import "normalize.css";
import ElementUI from "element-ui";
import SvgIcon from "vue-svgicon";
import "@/styles/index.scss";
import "@/icons/components";
import "@/permission";

import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import "@/registerServiceWorker";
import locale from 'element-ui/lib/locale/lang/en';
import VueScrollTo from 'vue-scrollto';
import VueI18n from 'vue-i18n';

import { Message, MessageBox } from "element-ui";

Vue.use(VueScrollTo);

// google map
import * as VueGoogleMaps from 'vue2-google-maps';

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAP_KEY || '',
    libraries: 'places',
  },
});

// airbrake
import AirbrakeClient from 'airbrake-js';

const airbrake = new AirbrakeClient({
  projectId: process.env.VUE_APP_AIRBRAKE_PROJECT_ID || '1',
  projectKey: process.env.VUE_APP_AIRBRAKE_PROJECT_KEY || '1',
  host: process.env.VUE_APP_AIRBRAKE_HOST || 'http://localhost:8080',
});

Vue.config.errorHandler = function (err, vm, info) {
  airbrake.notify({
    error: err,
    params: {info: info}
  });
}

// quill
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import VueQuillEditor, { Quill } from 'vue-quill-editor';
import { ImageDrop } from 'quill-image-drop-module';
import ImageResize from 'quill-image-resize-module';
import i18n from './i18n'

Quill.register('modules/imageDrop', ImageDrop);
Quill.register('modules/imageResize', ImageResize);

Vue.use(VueQuillEditor);

// other
Vue.use(ElementUI, { locale });

Vue.use(SvgIcon, {
  tagName: "svg-icon",
  defaultWidth: "1em",
  defaultHeight: "1em"
});

Vue.config.productionTip = false;

Vue.use(VueI18n);

Vue.config.errorHandler = (e) => {
  console.error(e);
  // Message({
  //   message: e.message,
  //   type: "error",
  //   duration: 5 * 1000
  // });
  throw e;
};

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
